module.exports = __webpack_public_path__ + "assets/img/ellipse.28ccea4d.svg";